import api from './api';

const FUNDS_SHAREHOLDERS_MS_URL = "fundos-cotistas";

export async function getSelfDistributor() {
    const { data } = await api.get(`${FUNDS_SHAREHOLDERS_MS_URL}/api/distributor/self`)

    return data;
}